import React from 'react';
import { List, ListItemButton, ListItemText, SxProps, Theme } from '@mui/material';

import { getSortedTemplateGroupNames } from '../../../selectors/annotationTemplates';
import { useAppSelector } from '../../hooks';

interface Props {
  selectedGroup: any;
  onSelectGroup: (group: string | null) => void;

  sx?: SxProps<Theme>;
}

export default function GroupList({ selectedGroup, onSelectGroup, sx }: Props) {
  const groups = useAppSelector(getSortedTemplateGroupNames);
  return (
    <List
      component="nav"
      sx={[
        {
          maxHeight: 400,
          overflowY: 'hidden',
          '&:hover': {
            overflowY: 'auto',
          },
          bgcolor: 'backContrast.main',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {groups.map((groupName: any) => (
        <ListItemButton
          key={groupName}
          onClick={() => onSelectGroup(groupName)}
          sx={groupName === selectedGroup ? { bgcolor: 'selectedList.main' } : null}
        >
          <ListItemText>{groupName}</ListItemText>
        </ListItemButton>
      ))}
    </List>
  );
}
